<template>
  <div class="header">
    <v-app-bar flat fixed class="header-wrap" height="48">
      <div class="header-title white--text">
        <v-toolbar-title class="logo-wrap" @click="navigatePush('home')">
          <img src="@/assets/images/nav/grx-logo.svg" alt="grx" />
        </v-toolbar-title>
      </div>

      <div class="avatar-wrap">
        <LangToggleHeader />
      </div>

      <!-- <v-app-bar-nav-icon
      class="hidden-md-and-up ml-auto mr-1"
      color="var(--white)"
      @click.stop=""
    ></v-app-bar-nav-icon> -->
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import LangToggleHeader from '@/components/LangToggle/LangToggleHeader';
export default {
  name: 'DefaultHeader',
  components: {
    LangToggleHeader
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    // ...mapGetters(['getCurrentPage', 'getUserInfo', 'getDrawerState'])
  },
  mounted() {},
  methods: {
    // ...mapActions(['logout_act']),
    // ...mapMutations(['SET_DRAWER_STATE']),
    // navigateRoute(id, link) {
    //   this.navigatePush(link);
    // }
  }
};
</script>

<style lang="stylus" scoped>
.theme--light {
  .header {
    position: relative;
    height: 48px;
  }

  &.v-app-bar {
    .header-title {
      margin-right: 40px;
      cursor: pointer;
      .header-logo {
        width: 100%;
        max-width: 150px;
      }
    }

    &.header-wrap {
      background-color: var(--header-color) !important;
      z-index: 100;

      .logo-wrap {
        width: 150px;
        height: 50px;
        padding: 0 5px;
        display: flex;
        align-items: center;
      }

      .header-items-wrap {
        .header-item {
          color: var(--white);
          font-size: 0.75rem;
          margin-right: calc(var(--gap-full) * 2);
          text-decoration: none;

          &-active {
            color: var(--link-color);
            text-decoration: underline;
          }
        }
      }

      .avatar-wrap {
        margin-left: auto;

        .avatar-btn {
          cursor: pointer;
        }
      }
    }

    /*  Remove hover effect */
    .x-hover::before {
      color: transparent;
    }
  }

  .profile-wrap {
    cursor: pointer;
    user-select: none;
  }
}
</style>
